const counter = (initialCount: number = 0) => {
  let count = initialCount;

  return {
    increment: () => ++count,
    decrement: () => --count,
    getCount: () => count,
    setCount: (newCount: number) => {
      count = newCount;
    },
    reset: () => {
      count = initialCount;
    },
  };
};

export default counter;
